import { type MessageDescriptor } from 'react-intl-next';

import GlobeIcon from '@atlaskit/icon/core/globe';
import GoalIcon from '@atlaskit/icon/core/goal';
//TODO: Update tags icon with new tile icon
import ProjectIcon from '@atlaskit/icon/core/project';
import { CustomLinkIcon } from '@atlaskit/temp-nav-app-icons/custom-link';
import { GoalsIcon } from '@atlaskit/temp-nav-app-icons/goals';
import { ProjectsIcon } from '@atlaskit/temp-nav-app-icons/projects';

import { getLogoVersion, type RovoLogo, RovoLogoFromLogo } from './icons';
import { messages } from './messages';

export interface NounConfig {
	displayName: MessageDescriptor;
	displayNamePlural: MessageDescriptor;
	Icon: RovoLogo;
}

export const NounKeys = {
	project: 'project',
	goal: 'goal',
	// tag: 'tag',
	AtlassianWebCrawler: 'atlassian-web-crawler',
};

export type NounKeys = (typeof NounKeys)[keyof typeof NounKeys];

export const isNounKey = (key: string): key is NounKeys => {
	return Object.values(NounKeys).includes(key);
};

export const nouns: Record<string, NounConfig> = {
	[NounKeys.project]: {
		displayName: messages.project,
		displayNamePlural: messages.projects,
		Icon: RovoLogoFromLogo(getLogoVersion(ProjectsIcon, ProjectIcon), 'Project'),
	},
	[NounKeys.goal]: {
		displayName: messages.goal,
		displayNamePlural: messages.goals,
		Icon: RovoLogoFromLogo(getLogoVersion(GoalsIcon, GoalIcon), 'Goal'),
	},
	//Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
	//Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
	// [NounKeys.tag]: {
	// 	displayName: messages.tag,
	// 	displayNamePlural: messages.tags,
	// 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
	// },
	[NounKeys.AtlassianWebCrawler]: {
		displayName: messages.webPage,
		displayNamePlural: messages.webPages,
		Icon: RovoLogoFromLogo(getLogoVersion(CustomLinkIcon, GlobeIcon), 'Atlassian Web Crawler'),
	},
};

export const NOUNS_ORDER: NounKeys[] = [
	NounKeys.project,
	NounKeys.goal,
	// NounKeys.tag,
	NounKeys.AtlassianWebCrawler, // Web Crawler is not a noun, we should improve this
];
